export enum RelationDirection {
    FATHER_TO_CHILD="FATHER_TO_CHILD",
    CHILD_TO_FATHER="CHILD_TO_FATHER",
    BIDIRECTIONAL="BIDIRECTIONAL",
    NO_DRAW="NO_DRAW"
}